<template>
  <div id="banner">
    <!--动态将图片轮播图的容器高度设置成与图片一致-->

    <el-carousel id="carousel_imgs" :height="bannerHeight + 'px'">
      <!--遍历图片地址,动态生成轮播图-->

      <el-carousel-item v-for="item in imgList" :key="item.id">
        <img :src="item.imgUrl" alt />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import { apiService } from "@/api/ApiService.js";
export default {
  name: "Banner",
  data() {
    return {
      bannerHeight: 550,
      imgList: []
    };
  },
  mounted() {
    this.init();
  },
  watch: { $route: "init" },
  methods: {
    init() {
      //获取屏幕宽度,如果屏幕宽度小于768,则将轮播图的高度设置为屏幕宽度的一半
      let width = document.documentElement.clientWidth;
      if (width < 768) {
        this.bannerHeight = width / 2;
      }
      let { articleModel } = this.$route.query;
      this.articleModel = articleModel;
      // 轮播图
      apiService.findHomeCarousel({ carouselType: articleModel }).then(res => {
        this.imgList = res.data;
      });
    }
  }
};
</script>
<style scoped>
#carousel_imgs img {
  height: 100%;
  width: 100%;
}
#carousel_imgs > div > div {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue